const ID = "G-73BB7NKCT2";

function gtag() {
  window.dataLayer.push(arguments);
}

function initGtag() {
  if (!ID) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", ID);
}

document.addEventListener("turbo:load", () => initGtag());
